import { render } from "./error.vue?vue&type=template&id=20af9744&ts=true"
import script from "./error.vue?vue&type=script&lang=ts"
export * from "./error.vue?vue&type=script&lang=ts"

import "./error.vue?vue&type=style&index=0&id=20af9744&lang=scss"

import exportComponent from "/home/runner/work/hub_thunnus/hub_thunnus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20af9744"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20af9744', __exports__)) {
    console.log('reload')
    api.reload('20af9744', __exports__)
  }
  
  module.hot.accept("./error.vue?vue&type=template&id=20af9744&ts=true", () => {
    console.log('re-render')
    api.rerender('20af9744', render)
  })

}


export default __exports__